/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-22 16:00:18
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-11-23 18:03:48
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/slice/reduxCommonFunctions.ts
 * @LastEditTime: 2021-03-24 15:49:53
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/slice/reduxCommonFunctions.ts
 */

export enum EnumReducers {
  button = 'button',
  text = 'text',
  homepage = 'homepage',
  productSearch = 'productSearch',
  shoppingCartPage = 'shoppingCartPage',
  notFoundPage = 'notFoundPage',
  promotion = 'promotion',
  tabBar = 'tabBar',
  maintenance = 'maintenance',
  contentPage = 'contentPage',
  profilePage = 'profilePage',
  allProductsPage = 'allProductsPage',
  appearance = 'appearance',
  navigation = 'navigation',
  header = 'header',
  footer = 'footer',
  megaMenu = 'megaMenu',
  animation = 'animation',
}
import {
  hasError,
  assData,
  defaultStatus,
  generateDefaultState,
  onCollapseOpen,
} from 'src/constrains/SalesChannelPreviewPageComponents/tools';

export {
  hasError,
  assData,
  defaultStatus,
  generateDefaultState,
  onCollapseOpen,
};
